/** @jsx jsx */
import React, { type ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useIsHydrateRenderMode,
	useSsrPlaceholders,
} from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';

const SEGMENT_KEY = 'queues-agent-view-top-layout-nav3';

export const useStylingPatch = () => {
	if (!fg('jsm_views_inside_queues_-_main_flag'))
		return { shouldUseStylingPatch: false, isNav3QueueIssueViewRoute: false };

	// With Nav4 always on, styling patch should never be applied
	return {
		shouldUseStylingPatch: false,
		isNav3QueueIssueViewRoute: false,
	};
};

export const QueueNav3StylingPatchContainer = ({ children }: { children: ReactNode }) => {
	const { shouldUseStylingPatch, isNav3QueueIssueViewRoute } = useStylingPatch();
	const isPageHydrating = useIsHydrateRenderMode();
	const displaySsrPlaceholderAttrs = useSsrPlaceholders();

	if (shouldUseStylingPatch || !fg('jsm_fix_queue_issue_view_navigate_back_state'))
		return (
			<div
				data-vc={
					fg('jsm_view_inside_queue_ssr_metric')
						? `${SEGMENT_KEY}${__SERVER__ && !isPageHydrating ? '-ssr' : ''}`
						: undefined
				}
				data-ssr-placeholder={
					__SERVER__ && displaySsrPlaceholderAttrs && fg('jsm_view_inside_queue_ssr_metric')
						? SEGMENT_KEY
						: undefined
				}
				data-ssr-placeholder-replace={
					__SERVER__ || !displaySsrPlaceholderAttrs || !fg('jsm_view_inside_queue_ssr_metric')
						? undefined
						: SEGMENT_KEY
				}
				css={!isNav3QueueIssueViewRoute && nav3PaddingStyles}
				data-testid="horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container"
			>
				{children}
			</div>
		);

	return children;
};

const nav3PaddingStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingTop: '137px',
	boxSizing: 'border-box',
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
});
